import axios from 'axios';
import { format } from 'date-fns';

// Step-1: Create a new Axios instance with a custom config.
// The timeout is set to 10s. If the request takes longer than
// that then the request will be aborted.

// Step-2: Create request, response & error handlers
const requestHandler = (request) => {
    // Token will be dynamic so we can use any app-specific way to always
    // fetch the new token before making the call
    return request;
};

const responseHandler = (response) => {
    if (response.status === 401 || response.status === 302) {
        window.location = '/';
    }
    return response;
};

const errorHandler = (error) => {
    if (error?.response?.status === 401 || error?.response?.status === 302) {
        window.location = '/';
    }
    return Promise.reject(error);
};

// Step-3: Configure/make use of request & response interceptors from Axios
// Note: You can create one method say configureInterceptors, add below in that,
// export and call it in an init function of the application/page.
axios.interceptors.request.use(
    (request) => requestHandler(request),
    (error) => errorHandler(error)
);

axios.interceptors.response.use(
    (response) => {
        return responseHandler(response);
    },
    (error) => errorHandler(error)
);

// Replace Date with string representation to bypass Date.toJSON() which uses Date.toISOString() to return UTC date
const dateTransformer = (data, headers) => {
    //Ignore FormData
    if (data instanceof FormData) {
        return data;
    }
    if (data instanceof Date) {
        // return moment(data).format('YYYY-MM-DDTHH:mm:ss.SSS');
        return format(data, 'yyyy-MM-dd\'T\'HH:mm:ss.SSS');
    }
    if (Array.isArray(data)) {
        return data.map((val) => dateTransformer(val));
    }
    if (typeof data === 'object' && data !== null) {
        return Object.fromEntries(
            Object.entries(data).map(([key, val]) => [
                key,
                dateTransformer(val, headers),
            ])
        );
    }
    return data;
};

axios.defaults.transformRequest = [dateTransformer].concat(
    axios.defaults.transformRequest
);

// Step-4: Export the newly created Axios instance to be used in different locations.
export default axios;
